module.exports = __webpack_public_path__ + "media/images/soar/site/woman_01-0a30dd96e7ff9759521b772a6b184acd.png";